import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * ThemeProvider 컴포넌트
 * Redux에서 테마 색상을 가져와서 CSS 변수로 설정
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
    // Redux에서 테마 색상 가져오기
    const withcookieData = useSelector((state: any) => state.withcookie?.withcookieData);
    const themeColor = withcookieData?.skin?.theme?.colorset?.primary || '#89a1be';
    
    useEffect(() => {
        // CSS 변수 설정
        const root = document.documentElement;
        root.style.setProperty('--theme-primary', themeColor);
        root.style.setProperty('--theme-primary-10', `${themeColor}1a`); // 10% opacity
        root.style.setProperty('--theme-primary-80', `${themeColor}cc`); // 80% opacity
    }, [themeColor]);
    
    return <>{children}</>;
}